<template>
  <table :class="`w-100 p-3 table--default table__border--${table_style}`">
    <thead :class="`table__head--${table_style}`">
      <tr>
        <th class="table__head--text">Foto</th>
        <th class="table__head--text">Item</th>
        <th class="table__head--text"></th>
        <th class="table__head--text"></th>
        <th class="table__head--text"></th>
        <th class="table__head--text"></th>
        <th class="table__head--text"></th>
        <th class="table__head--text">Stadagen</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(item, key) in table_data"
        :key="key"
        :class="`table__row--color`"
      >
        <td class="table__cell--default table--thumbnail">
          <img
            :src="`https://apps.kleyn.com:1919/prod/public/data/mainimage/${item.nummer}/original`"
            class="thumbnail"
          />
        </td>
        <td class="table__cell--default">
          <p><strong>Item</strong></p>
          <div>
            <ImageHover :itemnummer="item.nummer" :bu="item.bu" />
            {{ item.soortnaam }}<br />
            {{ item.merknaam }}<br />
            {{ item.typenaam }}<br />
            {{ item.regjaar }}
          </div>
        </td>
        <td class="table__cell--default">
          <p><strong>Kosten op verkooporder</strong></p>
          <div>
            Transport weg<br />
            Transport zee<br />
            Documenten<br />
            Werkplaats<br />
            Spuitwerk<br />
            Commissie<br />
            Extra opbrengsten<br />
            <hr />
            <strong>Totaal</strong>
          </div>
        </td>
        <td class="table__cell--default">
          <p><strong>Gepland</strong></p>
          <div>
            € {{ item.p_transport }}<br />
            € {{ item.p_transportzee }}<br />
            € {{ item.p_documenten }}<br />
            € {{ item.p_werkplaats }}<br />
            € {{ item.p_spuitwerk }}<br />
            € {{ item.p_commissie }}<br />
            € {{ item.p_extra }}<br />
            <hr />
            <strong>€ {{ item.geplandkosten }}</strong>
          </div>
        </td>
        <td class="table__cell--default">
          <p><strong>Werkelijk</strong></p>
          <div>
            € {{ item.w_transportweg }}<br />
            € {{ item.w_transportzee }}<br />
            € {{ item.w_documenten }}<br />
            € {{ item.w_werkplaats }}<br />
            € {{ item.w_spuitwerk }}<br />
            € {{ item.w_commissie }}<br />
            € {{ item.w_extra }}<br />
            <hr />
            <strong>€ {{ item.werkelijkkosten }}</strong>
          </div>
        </td>
        <td class="table__cell--default">
          <p><strong>Afwijking</strong></p>
          <div>
            <span :class="{ 'text--red': toNumber(item.afwijking_transport) > 0 }">€ {{ item.afwijking_transport }}</span><br />
            <span :class="{ 'text--red': toNumber(item.afwijking_transportzee) > 0 }">€ {{ item.afwijking_transportzee }}</span><br />
            <span :class="{ 'text--red': toNumber(item.afwijking_documenten) > 0 }">€ {{ item.afwijking_documenten }}</span><br />
            <span :class="{ 'text--red': toNumber(item.afwijking_werkplaats) > 0 }">€ {{ item.afwijking_werkplaats }}</span><br />
            <span :class="{ 'text--red': toNumber(item.afwijking_spuitwerk) > 0 }">€ {{ item.afwijking_spuitwerk }}</span><br />
            <span :class="{ 'text--red': toNumber(item.afwijking_commissie) > 0 }">€ {{ item.afwijking_commissie }}</span><br />
            <span :class="{ 'text--red': toNumber(item.afwijking_extra) > 0 }">€ {{ item.afwijking_extra }}</span><br />
            <hr />
            <strong :class="{ 'text--red': item.percentage_kosten > 100 }"
              >{{ Math.round(item.percentage_kosten) }}%</strong
            >
          </div>
        </td>
        <td class="table__cell--default">
          <p><strong>Totale kosten</strong></p>
          <div>
            Inkoopprijs: € {{ item.inkoopbedrag }}<br />
            Kosten: € {{ item.totaalkosten }}<br />
            Verkoopprijs: € {{ item.verkoopbedrag }}<br />
            <hr>
            Resultaat: € {{ item.opbrengst }}
          </div>
        </td>
        <td class="table__cell--default">
          <p><strong>Stadagen</strong></p>
          <div>
            {{ item.stadagen }}<br />
            <br />
            <br />
            <hr />
            <p><strong>Afschrijving</strong></p>
            € {{ item.afschrijving }}
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import ImageHover from "@/components/ImageHover.vue";

export default {
  props: {
    table_data: [Object, Array],
    table_style: [Number, String],
  },
  components: { ImageHover },
  methods: {
    toNumber(value) {
      if (typeof value === "number") return value;
      return parseFloat(String(value).replace(/\./g, "").replace(",", "."));
    },
  },
};
</script>
